var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStats(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.28137 7.29021C9.69559 7.29021 10.0314 7.62599 10.0314 8.04021V13.8713C10.0314 14.2855 9.69559 14.6213 9.28137 14.6213C8.86716 14.6213 8.53137 14.2855 8.53137 13.8713V8.04021C8.53137 7.62599 8.86716 7.29021 9.28137 7.29021Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.248 4.5C13.6623 4.5 13.998 4.83579 13.998 5.25V13.8713C13.998 14.2855 13.6623 14.6213 13.248 14.6213C12.8338 14.6213 12.498 14.2855 12.498 13.8713V5.25C12.498 4.83579 12.8338 4.5 13.248 4.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 10.3716C5.66421 10.3716 6 10.7073 6 11.1216V13.8713C6 14.2855 5.66421 14.6213 5.25 14.6213C4.83579 14.6213 4.5 14.2855 4.5 13.8713V11.1216C4.5 10.7073 4.83579 10.3716 5.25 10.3716Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66872 1.81899C2.60733 0.812133 3.9431 0.25 5.51714 0.25H13.4829C15.0605 0.25 16.3966 0.811831 17.3346 1.81934C18.267 2.8208 18.75 4.20154 18.75 5.74738V13.2526C18.75 14.7985 18.267 16.1792 17.3346 17.1807C16.3966 18.1882 15.0605 18.75 13.4829 18.75H5.51714C3.93953 18.75 2.60336 18.1882 1.66536 17.1807C0.732997 16.1792 0.25 14.7985 0.25 13.2526V5.74738C0.25 4.20063 0.735568 2.82 1.66872 1.81899ZM2.76592 2.84181C2.13467 3.51896 1.75 4.51203 1.75 5.74738V13.2526C1.75 14.4889 2.13319 15.4818 2.76321 16.1585C3.38759 16.8292 4.31 17.25 5.51714 17.25H13.4829C14.69 17.25 15.6124 16.8292 16.2368 16.1585C16.8668 15.4818 17.25 14.4889 17.25 13.2526V5.74738C17.25 4.51111 16.8668 3.51816 16.2368 2.84146C15.6124 2.1708 14.69 1.75 13.4829 1.75H5.51714C4.31452 1.75 3.39172 2.1705 2.76592 2.84181Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStats);
export default __webpack_public_path__ + "static/media/stats.dca3c9751b1e0bf69fad60b4cf1947e8.svg";
export { ForwardRef as ReactComponent };